<template>
  <div class="pc-search">
    <el-form class="pc-search-main-formOne" :model="keywordData" :inline="true">
      <el-form-item label="名称" class="title">
        <el-input
          v-model="keywordData.title_keywords[0]"
          placeholder=""
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="编号" class="number">
        <el-input-number
          v-model.number="keywordData.id"
          placeholder=""
        ></el-input-number>
      </el-form-item>
      <br />
      <el-form-item label="标签" class="keyword">
        <keywordsinput
          :maxLen="18"
          v-model="keywordData.tags_keywords"
        ></keywordsinput>
      </el-form-item>

      <el-form-item label="授课学者" placeholder="学者" class="teacher">
        <el-autocomplete
          v-model="selectedTeacher.chinese_name"
          :fetch-suggestions="searchScholar"
          @select="handleSelect"
          placeholder="选择学者"
          clearable
        >
        </el-autocomplete>
      </el-form-item>

      <el-form-item label="状态" placeholder="状态" class="status">
        <el-select v-model="keywordData.status" placeholder="有效" clearable>
          <el-option label="有效" value="1">有效</el-option>
          <el-option label="无效" value="0">无效</el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <button class="pc-search-btn" @click="search">筛选</button>
  </div>
</template>



<script>
import { lectureScholarDropDown_Api } from "@/apis/lecture.api";
export default {
  data() {
    return {
      keywordData: {
        id: null,
        title_keywords: [""],
        tags_keywords: [],
        status: null,
        scholar_id: null,
        series_id: null,
      },
      // 学者列表
      selectedTeacher: { chinese_name: "" },
      teacherList: [],
    };
  },
  methods: {
    searchScholar(queryString, callback) {
      lectureScholarDropDown_Api(queryString).then((res) => {
        for (let i of res.data) {
          i.value = i.chinese_name;
        }
        this.teacherList = res.data;
        callback(this.teacherList);
      });
    },
    handleSelect(item) {
      this.keywordData.scholar_id = item.id;
      console.log(this.teacherList.scholar_id);
    },
    search() {
      this.$emit("search", this.keywordData);
    },
  },
};
</script>
<style lang="scss" scoped>
.pc-search {
  @include table-search;
  .title {
    width: 400px;
  }
  .keyword {
    width: 400px;
    /deep/ .qh-tag {
      line-height: 24px;
    }
  }
  .number {
    width: 300px;
    /deep/ .el-input-number {
      width: 190px;
    }
  }
  .teacher {
    width: 300px;
    /deep/ .el-autocomplete {
      width: 190px;
    }
  }
  .status {
    width: 200px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/admin/lecture/components/SeriesSearch.vue